<template>
  <div :class="'question_paging-wrapper custom-scroll ' + this.pagingClass">
    <div class="inner-wrapper">
      <div class="inner" :class="{ minimized: minimize }">
        <a
          href="#"
          v-for="(question, i) in questions"
          :key="question.id"
          class="question_paging"
          :class="{
            correct: user_answers[question.id] && user_answers[question.id].correct,
            wrong: user_answers[question.id] && !user_answers[question.id].correct,
            current: currentQuestionIndex == i,
          }"
          @click.prevent="setCurrentQuestoin(i, question)"
        >
          {{ i + 1 }}
        </a>
        <a
          href="#"
          class="question_paging"
          :class="{ active: currentQuestionIndex == user_answers.length }"
          @click.prevent="next"
          v-if="questions.length > user_answers.length"
        >
          {{ user_answers.length + 1 }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['questions', 'user_answers', 'currentQuestionIndex'],
  data() {
    return {
      minimize: false,
      pagingClass: '',
    };
  },
  methods: {
    setCurrentQuestoin(index, question) {
      this.$emit('setCurrentQuestoinIndex', index);
    },
     handleScroll () {
      if(window.scrollY > 59){
          this.pagingClass = 'scrolled'
      }else{
          this.pagingClass = ''
      }
    }
  },
  mounted() {
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style lang="scss" scoped></style>
